<div
  class="content-skeleton loading"
  *ngIf="isLoading; else content"
  [ngStyle]="skeletonStyles"
></div>

<ng-template #content>
  <slot></slot>
</ng-template>
